import React from "react";
import { Card, Typography, Select, Space } from "antd";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";

const { Title, Text } = Typography;
const { Option } = Select;

// Sample data expanded for a fuller chart view
export const performanceData = [
    { week: "Jan", leads: 580, deals: 450, accounts: 240, contacts: 240 },
    { week: "Feb", leads: 640, deals: 530, accounts: 360, contacts: 360 },
    { week: "Mar", leads: 750, deals: 670, accounts: 480, contacts: 480 },
    { week: "Apr", leads: 820, deals: 780, accounts: 500, contacts: 500 },
    { week: "May", leads: 650, deals: 530, accounts: 340, contacts: 340 },
    { week: "Jun", leads: 450, deals: 300, accounts: 180, contacts: 180 },
    { week: "Jul", leads: 680, deals: 440, accounts: 280, contacts: 280 },
    { week: "Aug", leads: 900, deals: 680, accounts: 570, contacts: 570 },
    { week: "Sep", leads: 690, deals: 650, accounts: 490, contacts: 490 },
    { week: "Oct", leads: 630, deals: 490, accounts: 320, contacts: 320 },
    { week: "Nov", leads: 870, deals: 680, accounts: 380, contacts: 380 },
    { week: "Dec", leads: 720, deals: 710, accounts: 580, contacts: 580 },
];

export const chartSeries = [
    { key: "leads", label: "Leads", color: "#22c55e" },    // Green
    { key: "deals", label: "Deals", color: "#f97316" },    // Orange
    { key: "accounts", label: "Accounts", color: "#06b6d4" }, // Cyan
    { key: "contacts", label: "Contacts", color: "#2dd4bf" }, // Teal
];

const BDEPerformanceChart: React.FC = () => {
    return (
        <Card
            bordered={false}
            className="w-full rounded-xl shadow-sm border border-gray-100 mt-4"
            bodyStyle={{ padding: "24px" }}
        >
            {/* Header Section */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
                <div>
                    <Title level={4} className="!m-0 !font-semibold text-gray-800">
                        Performance
                    </Title>

                </div>

                <Space size="middle">
                    <Select
                        defaultValue="top"
                        style={{ width: 140 }}
                        className="rounded-lg"
                    >
                        <Option value="top">Top Performer</Option>
                        <Option value="average">Average</Option>
                    </Select>
                    <Select
                        placeholder="Select Employee"
                        style={{ width: 160 }}
                        className="rounded-lg"
                    >
                        <Option value="1">John Doe</Option>
                        <Option value="2">Jane Smith</Option>
                    </Select>
                </Space>
            </div>

            {/* Chart Section */}
            <div className="w-full h-[350px]">
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        data={performanceData}
                        margin={{ top: 10, right: 10, left: -20, bottom: 0 }}
                    >
                        <CartesianGrid
                            strokeDasharray="3 3"
                            vertical={false}
                            stroke="#f0f0f0"
                        />
                        <XAxis
                            dataKey="week"
                            axisLine={false}
                            tickLine={false}
                            tick={{ fill: '#9ca3af', fontSize: 12 }}
                            dy={10}
                        />
                        <YAxis
                            axisLine={false}
                            tickLine={false}
                            tick={{ fill: '#9ca3af', fontSize: 12 }}
                        />
                        <Tooltip
                            contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                        />

                        {/* Legend positioned at bottom left as per Figma */}
                        <Legend
                            verticalAlign="bottom"
                            align="left"
                            iconType="square"
                            iconSize={12}
                            wrapperStyle={{ paddingTop: '30px', fontSize: '12px' }}
                        />

                        {chartSeries.map((series) => (
                            <Line
                                key={series.key}
                                name={series.label}
                                type="monotone"
                                dataKey={series.key}
                                stroke={series.color}
                                strokeWidth={2.5}
                                dot={{ r: 4, fill: "#fff", strokeWidth: 2, stroke: series.color }}
                                activeDot={{ r: 6, strokeWidth: 0 }}
                            />
                        ))}
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </Card>
    );
};

export default BDEPerformanceChart;